/**
 * Skills Section for Assistant Profile
 * Allows candidates to select skills that match JOB_REQUIRED_SKILLS
 */
import { Card } from "@/components/ui/card";
import { JOB_REQUIRED_SKILLS } from "@/lib/profileOptions";

export default function SkillsSection({ skills, setSkills }) {
  const toggleSkill = (value) => {
    if (skills.includes(value)) {
      setSkills(skills.filter(s => s !== value));
    } else {
      setSkills([...skills, value]);
    }
  };

  return (
    <Card className="bg-white/[0.03] border-white/5 p-8 mb-6">
      <h2 className="text-xl font-semibold mb-2">Your Skills</h2>
      <p className="text-white/50 mb-6">Select all the skills you can confidently offer on a job</p>
      
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
        {JOB_REQUIRED_SKILLS.map((skill) => {
          const isSelected = skills.includes(skill.value);
          return (
            <button
              key={skill.value}
              type="button"
              onClick={() => toggleSkill(skill.value)}
              className={`p-3 text-sm text-left rounded-sm border transition-all ${
                isSelected 
                  ? "bg-white/10 border-white/40 text-white" 
                  : "bg-white/[0.03] border-white/10 text-white/60 hover:border-white/20"
              }`}
              data-testid={`skill-${skill.value}`}
            >
              {skill.label}
            </button>
          );
        })}
      </div>
      
      {skills.length > 0 && (
        <p className="text-white/40 text-sm mt-4">{skills.length} skill{skills.length !== 1 ? 's' : ''} selected</p>
      )}
    </Card>
  );
}
